import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { all_routes } from "../../../../Router/all_routes";
import { Popconfirm, Table } from "antd";
import { Edit, Trash2 } from "feather-icons-react/build/IconComponents";
import { Info } from "feather-icons-react/build/IconComponents";
import { useForm } from "react-hook-form";
import InputField from "../../../components/Input";
import BrandServices from "../../../../services/Brand";
import ProductServices from "../../../../services/Product";
import SizeServices from "../../../../services/Size";
import { v4 as uuidv4 } from 'uuid'
import { useSelector } from "react-redux";
import SelectField from "../../../components/Select";
import StoreServices from "../../../../services/Store";

const Form = ({ onSubmit, loading }) => {

  const route = all_routes;
  const navigate = useNavigate();
  const { id } = useParams();
  const { state } = useLocation();

  const { register, handleSubmit, formState: { errors }, control, setValue } = useForm();
  const { register: register2, handleSubmit: handleSubmit2, formState: { errors: errors2 }, reset: reset2, setValue: setValue2 } = useForm();
  const { register: register3, handleSubmit: handleSubmit3, formState: { errors: errors3 }, reset: reset3, setValue: setValue3 } = useForm();

  // *For Update Invoice Row
  const [updateData, setUpdateData] = useState();

  // *For Stores
  const [stores, setStores] = useState([]);
  const [selectedStoreFrom, setSelectedStoreFrom] = useState(null);
  const [selectedStoreTo, setSelectedStoreTo] = useState(null);

  // *For Brands
  const [brands, setBrands] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState(null);

  // *For Products
  const [products, setProducts] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);

  // *For Sizes
  const [sizes, setSizes] = useState([]);
  const [selectedSize, setSelectedSize] = useState(null);

  // *For Product Rows
  const [productRows, setProductRows] = useState([]);

  const { userData } = useSelector((state) => {
    return {
      userData: state.user_data
    }
  });

  // *For Get Stores
  const getStores = async () => {
    try {
      let params = {
        page: 1,
        limit: 50,
        active: true
      }
      const { data } = await StoreServices.getStores(params)
      setStores(data)
    } catch (error) {
      console.log('getStores => error:', error)
    }
  }

  // *For Get Brands
  const getBrands = async () => {
    try {
      let params = {
        page: 1,
        limit: 50,
        active: true
      }
      const { data } = await BrandServices.getBrands(params)
      setBrands(data)
    } catch (error) {
      console.log('getBrands => error:', error)
    }
  }

  // *For Get Products
  const getProducts = async () => {
    try {
      let params = {
        page: 1,
        limit: 50,
        active: true
      }
      const { data } = await ProductServices.getProducts(params)
      setProducts(data)
    } catch (error) {
      console.log('getProducts => error:', error)
    }
  }

  // *For Get Sizes
  const getSizes = async () => {
    try {
      let params = {
        page: 1,
        limit: 50,
        active: true
      }
      const { data } = await SizeServices.getSizes(params)
      setSizes(data)
    } catch (error) {
      console.log('getSizes => error:', error)
    }
  }

  // *For Submit Form
  const submitForm = async (formData) => {
    try {

      const stockItems = []
      productRows.forEach(e => {
        let item = {
          brand_id: e?.brand?.id,
          item_id: e?.product?.id,
          size_id: e?.size?.id,
          description: e?.description,
          quantity: e?.quantity
        }
        stockItems.push(item)
      })

      let obj = {
        user_id: userData?.store?.id,
        reference_no: formData?.ref,
        from_store: selectedStoreFrom?.id,
        to_store: selectedStoreTo?.id,
        remarks: formData?.remarks,
        reference_no: formData?.reference_no,
        items: stockItems
      }
      console.log(obj)
      onSubmit(obj)
    } catch (error) {
      console.log('submitForm => error:', error)
    }
  }

  // *For Submit Product Row
  const submitProductRow = async (formData) => {
    try {
      let obj = {
        brand: selectedBrand,
        product: selectedProduct,
        size: selectedSize,
        description: formData?.description,
        quantity: parseInt(formData?.quantity),
      }
      if (updateData?.id) {
        const index = productRows.findIndex((e) => e.id === updateData?.id)

        if (index !== -1) {
          const updatedProductRows = [...productRows];
          updatedProductRows[index] = { ...updatedProductRows[index], ...obj };
          setProductRows(updatedProductRows);
        }

      } else {
        const updateProductRow = [...productRows]
        updateProductRow.push({ id: uuidv4(), ...obj })
        setProductRows(updateProductRow)
      }
      reset2();
      setSelectedBrand(null)
      setSelectedProduct(null)
      setSelectedSize(null)
      const btn = document.getElementById('modalClose')
      btn.click();
    } catch (error) {
      console.log('submitForm => error:', error)
    }
  }

  // *For Delete Row
  const deleteProductRow = (id) => {
    try {
      const index = productRows.findIndex((e) => e.id === id)
      let updateProductRow = [...productRows]
      updateProductRow.splice(index, 1);
      setProductRows(updateProductRow)
    } catch (error) {
      console.log('deleteRow => error:', error)
    }
  }

  const columns = [
    {
      title: "Brand",
      dataIndex: "brand",
      render: (text) => (
        <span>
          {text?.name}
        </span>
      ),
    },
    {
      title: "Product",
      dataIndex: "product",
      render: (text) => (
        <span>
          {text?.name}
        </span>
      ),
    },
    {
      title: "Size",
      dataIndex: "size",
      render: (text) => (
        <span>
          {text?.name}
        </span>
      ),
    },
    {
      title: "Description",
      dataIndex: "description",
      render: (text) => (
        <span>
          {text}
        </span>
      ),
    },
    {
      title: "Qty",
      dataIndex: "quantity",
      render: (text) => (
        <span>
          {text}
        </span>
      ),
    },
    {
      title: "Actions",
      dataIndex: "actions",
      key: "actions",
      render: (text, record) => (
        <div className="action-table-data">
          <div className="edit-delete-action">
            <div className="input-block add-lists"></div>
            <Link className="me-2 p-2"
              to="#"
              data-bs-toggle="modal"
              data-bs-target="#open-modal"
              onClick={() => setUpdateData(record)}
            >
              <Edit className="feather-edit" />
            </Link>
            <Link className="confirm-text p-2">
              <Popconfirm title="Sure to delete?" onConfirm={() => deleteProductRow(record.key)}>
                <Trash2 className="feather-trash-2" />
              </Popconfirm>
            </Link>
          </div>
        </div>
      ),
    },
  ];

  // *For Get Stock Transfer Details
  const getStockTransferDetails = async () => {
    try {
      // const { data } = await SaleInvoiceServices.getSaleInvoiceById(id)
      // const data = state
      // console.log('getStockTransferDetails => data:', data)
      // setProductRows(data?.sale_invoice_items)
    } catch (error) {
      ErrorToaster(error)
    }
  }

  // *For Create Brand
  const createBrand = async (name) => {
    try {
      let obj = {
        name: name,
        remarks: "",
        is_active: true
      }
      const { data } = await BrandServices.createBrand(obj)
      getBrands()
      setSelectedBrand({ id: data[0].id, name: data[0].name });
      setValue("brand", data[0].name);
    } catch (error) {
      console.log('createBrand => error:', error)
    }
  }

  // *For Create Product
  const createProduct = async (name) => {
    try {
      let obj = {
        name: name,
        price: 1,
        quantity: 1,
        remarks: "",
        code: " ",
        spiff: 0,
        brand_id: 1,
        category_id: 1,
        bay_id: 1,
        section_id: 1,
        is_active: true,
      }
      const { data } = await ProductServices.createProduct(obj)
      getProducts()
      setSelectedProduct({ id: data[0].id, name: data[0].name });
      setValue("product", data[0].name);
    } catch (error) {
      console.log('createProduct => error:', error)
    }
  }

  // *For Create Size
  const createSize = async (name) => {
    try {
      let obj = {
        name: name,
        remarks: "",
        is_active: true
      }
      const { data } = await SizeServices.createSize(obj)
      getSizes()
      setSelectedSize({ id: data[0].id, name: data[0].name });
      setValue("size", data[0].name);
    } catch (error) {
      console.log('createSize => error:', error)
    }
  }

  const getProductByBarcode = async (formData) => {
    try {

    } catch (error) {
      ErrorToaster(error)
    }
  }

  useEffect(() => {
    getStores()
    getBrands()
    getProducts()
    getSizes()
  }, []);

  useEffect(() => {
    if (updateData) {
      setValue2('brand', updateData?.brand?.name)
      setValue2('product', updateData?.product?.name)
      setValue2('size', updateData?.size?.name)
      setValue2('description', updateData?.description)
      setValue2('quantity', updateData?.quantity)
      setSelectedBrand(updateData?.brand)
      setSelectedProduct(updateData?.product)
      setSelectedSize(updateData?.size)
    }
  }, [updateData]);

  useEffect(() => {
    if (id) {
      getStockTransferDetails()
    }
  }, [id]);

  return (
    <>
      <div className="modal fade" id="open-modal">
        <div className="modal-dialog modal-dialog-centered custom-modal-two" style={{ maxWidth: '600px' }}>
          <div className="modal-content">
            <div className="page-wrapper-new p-0">
              <div className="content">
                <div className="modal-header border-0 custom-modal-header">
                  <div className="page-title">
                    <h4>{updateData?.id ? "Update Item" : "Create Item"}</h4>
                  </div>
                  <button
                    type="button"
                    className="close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div className="modal-body custom-modal-body new-employee-field">
                  <form onSubmit={handleSubmit2(submitProductRow)}>
                    <div className="row">
                      <div className="col-lg-4 col-sm-6 col-12">
                        <div className="mb-3">
                          <SelectField
                            addNew={(newValue) => createBrand(newValue)}
                            label={"Brand"}
                            options={brands}
                            selected={selectedBrand}
                            onSelect={(value) => setSelectedBrand(value)}
                            error={errors2?.brand?.message}
                            register={register2("brand", {
                              required: 'Please select brand.'
                            })}
                          />
                        </div>
                      </div>
                      <div className="col-lg-4 col-sm-6 col-12">
                        <div className="mb-3">
                          <SelectField
                            addNew={(newValue) => createProduct(newValue)}
                            label={"Product"}
                            options={products}
                            selected={selectedProduct}
                            onSelect={(value) => setSelectedProduct(value)}
                            error={errors2?.product?.message}
                            register={register2("product", {
                              required: 'Please select product.'
                            })}
                          />
                        </div>
                      </div>
                      <div className="col-lg-4 col-sm-6 col-12">
                        <div className="mb-3">
                          <InputField
                            label="Quantity"
                            error={errors2?.quantity?.message}
                            register={register2("quantity", {
                              required: 'Please enter quantity.'
                            })}
                          />
                        </div>
                      </div>
                      <div className="col-lg-4 col-sm-6 col-12">
                        <div className="mb-3">
                          <SelectField
                            addNew={(newValue) => createSize(newValue)}
                            label={"Size"}
                            options={sizes}
                            selected={selectedSize}
                            onSelect={(value) => setSelectedSize(value)}
                            error={errors2?.size?.message}
                            register={register2("size", {
                              required: 'Please select size.'
                            })}
                          />
                        </div>
                      </div>
                      <div className="col-lg-7 col-sm-12 col-12">
                        <div className="mb-3">
                          <InputField
                            label="Description"
                            inputType="textarea"
                            placeholder="Type Description"
                            register={register2("description")}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="modal-footer-btn">
                      <button
                        id="modalClose"
                        type="button"
                        className="btn btn-cancel me-2"
                        data-bs-dismiss="modal"
                      >
                        Cancel
                      </button>
                      <button
                        className="btn btn-submit"
                        type="submit"
                      >
                        Submit
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <form onSubmit={handleSubmit(submitForm)}>
        <div className="card">
          <div className="card-body add-product pb-0" style={{ padding: '1rem' }}>

            {/* Information & Billing & Shipping Details */}
            <div className="mb-2">
              <div className="addproduct-icon" style={{ paddingBottom: '10px', marginBottom: '10px' }}>
                <h5>
                  <Info className="add-info" />
                  <span>Information</span>
                </h5>
              </div>
              <div className="row">
                <div className="col-lg-3 col-sm-3 col-6">
                  <div className="mb-1 add-product">
                    <SelectField
                      label={"From Store"}
                      options={stores}
                      selected={selectedStoreFrom}
                      onSelect={(value) => setSelectedStoreFrom(value)}
                      error={errors2?.storeFrom?.message}
                      register={register2("storeFrom", {
                        required: 'Please select store from.'
                      })}
                    />
                  </div>
                </div>
                <div className="col-lg-3 col-sm-3 col-6">
                  <div className="mb-1 add-product">
                    <SelectField
                      label={"To Store"}
                      options={stores}
                      selected={selectedStoreTo}
                      onSelect={(value) => setSelectedStoreTo(value)}
                      error={errors2?.storeTo?.message}
                      register={register2("storeTo", {
                        required: 'Please select store to.'
                      })}
                    />
                  </div>
                </div>
                <div className="col-lg-4 col-sm-6 col-4">
                  <div className="mb-1 add-product">
                    <InputField
                      label="Remarks"
                      type="text"
                      placeholder="Type Remarks"
                      register={register("remarks")}
                    />
                  </div>
                </div>
                <div className="col-lg-4 col-sm-6 col-4">
                  <div className="mb-1 add-product">
                    <InputField
                      label="Reference No."
                      type="text"
                      placeholder="Type Reference No."
                      register={register("reference_no", {
                        required: 'Please enter reference no.'
                      })}
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Sale */}
            <div className="mb-2">
              <div className="addproduct-icon" style={{ paddingBottom: '10px', marginBottom: '10px' }}>
              </div>
              <div className="row">
                <div className="col-lg-3 col-sm-3 col-6 my-2">
                  <div className="mb-1 add-product">
                    <InputField
                      placeholder="Scan here"
                      type="text"
                      error={errors3?.barcode?.message}
                      register={register3("barcode", {
                        required: 'Please enter sku/barcode.',
                      })}
                    />
                  </div>
                </div>
                <div className="col-lg-3 col-sm-3 col-6 my-2">
                  <button type="button"
                    className="btn btn-submit me-2"
                    onClick={handleSubmit3(getProductByBarcode)}
                  // data-bs-toggle="modal"
                  // data-bs-target="#open-modal"
                  >
                    Search
                  </button>
                  <button type="button"
                    className="btn btn-info"
                    data-bs-toggle="modal"
                    data-bs-target="#open-modal"
                  >
                    Add Manual
                  </button>
                </div>
              </div>

              <Table
                className="table datanew dataTable no-footer custom-table"
                columns={columns}
                dataSource={productRows}
                pagination={false}
              />

              {/* <div className="row mt-3 mb-1">
                <div className="col-lg-3 col-sm-6 col-12">
                  <button type="button"
                    className="btn btn-submit"
                    data-bs-toggle="modal"
                    data-bs-target="#open-modal"
                  >
                    Add Item
                  </button>
                </div>
              </div> */}
            </div>

          </div>
        </div>
        <div className="col-lg-12">
          <div className="btn-addproduct mb-4">
            <Link to={route.sales} className="btn btn-cancel me-2">
              Cancel
            </Link>
            <button
              type="submit"
              className="btn btn-submit"
              disabled={loading}
            >
              Submit
            </button>
          </div>
        </div>
      </form>
    </>
  );
};

export default Form;
